/* Gentle Beauty — cart drawer & cart page enhancements (free shipping animation, recommendations upsell,
   save for later, gift attribute / gift wrap, promo code, live counts). Works alongside Dawn cart.js / cart-drawer.js. */
(function () {
  'use strict';
  if (window.GBCartDrawer) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cartUrl = function () { return (window.routes && window.routes.cart_url) || '/cart'; };
  var lastPct = null;
  var recCache = {};

  /* ---------- Mini card variant select (shared with gb-recommendations.js) ---------- */
  if (!window.__gbMiniVariant) {
    window.__gbMiniVariant = true;
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-gb-mini-variant]');
      if (!select) return;
      var card = select.closest('[data-gb-mini]'), opt = select.selectedOptions[0];
      if (!card || !opt) return;
      var add = $('[data-gb-add]', card), check = $('[data-gb-pair], [data-gb-fbt-check]', card), price = $('[data-gb-mini-price]', card);
      if (add) add.setAttribute('data-gb-add', select.value);
      if (check) { check.value = select.value; check.dataset.price = opt.dataset.price; check.dispatchEvent(new Event('change', { bubbles: true })); }
      if (price && opt.dataset.priceLabel) price.textContent = opt.dataset.priceLabel;
    });
  }

  /* ---------- Free shipping bar: animate from previous value, sparkle on unlock ---------- */
  function animateShipping(scope) {
    $$('[data-gb-free-ship]:not([data-anim])', scope).forEach(function (el) {
      el.setAttribute('data-anim', '');
      var fill = $('[data-gb-ship-fill]', el);
      var pct = Number(el.dataset.pct) || 0;
      var from = lastPct === null ? 0 : lastPct;
      if (fill && from !== pct) {
        fill.style.transition = 'none';
        fill.style.setProperty('--gb-ship', from + '%');
        void fill.offsetWidth;
        fill.style.transition = '';
        window.requestAnimationFrame(function () { fill.style.setProperty('--gb-ship', pct + '%'); });
      }
      if (lastPct !== null && lastPct < 100 && pct >= 100) {
        setTimeout(function () { el.classList.add('is-celebrating'); }, 500);
      }
      lastPct = pct;
    });
  }

  /* ---------- Upsell: swap in product recommendations ---------- */
  function initUpsell(scope) {
    $$('[data-gb-cart-upsell]:not([data-init])', scope).forEach(function (box) {
      box.setAttribute('data-init', '');
      var list = $('[data-gb-upsell-list]', box);
      var limit = Number(box.dataset.limit) || 2;
      var exclude = (box.dataset.exclude || '').split(',').filter(Boolean);
      var render = function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = $$('[data-gb-mini]', tmp).filter(function (c) {
          return exclude.indexOf(c.dataset.productId) < 0 && c.dataset.available !== 'false';
        }).slice(0, limit);
        if (!cards.length) { if (!list.children.length) box.hidden = true; return; }
        list.innerHTML = '';
        cards.forEach(function (c, i) {
          c.classList.add('gb-mini--upsell');
          c.classList.toggle('gb-mini--featured', i === 0);
          list.appendChild(c);
        });
        box.hidden = false;
      };
      var url = box.dataset.url;
      if (!url) { if (!list.children.length) box.hidden = true; return; }
      if (recCache[url] !== undefined) return render(recCache[url]);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var tpl = doc.querySelector('template[data-gb-reco-mini]');
          recCache[url] = tpl ? tpl.innerHTML : '';
          render(recCache[url]);
        })
        .catch(function () { if (!list.children.length) box.hidden = true; });
    });
  }

  function syncDrawerState() {
    var drawer = $('cart-drawer');
    if (!drawer) return;
    var empty = !!$('#CartDrawer [data-gb-cart-empty]', drawer);
    drawer.classList.toggle('is-empty', empty);
  }

  function init(scope) {
    scope = scope || document;
    animateShipping(scope);
    initUpsell(scope);
    syncDrawerState();
  }

  /* ---------- Observe Dawn re-renders ---------- */
  function observe(el) {
    if (!el || el.__gbObserved || !('MutationObserver' in window)) return;
    el.__gbObserved = true;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { init(el); }, 30); }).observe(el, { childList: true, subtree: true });
  }

  /* ---------- Live cart data (counts, cart page summary refresh) ---------- */
  function refreshPage(sourceIsCartItems) {
    fetch(cartUrl() + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-gb-cart-count-text]').forEach(function (el) {
        el.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? el.dataset.singular : el.dataset.plural);
      });
      if (window.GB && GB.cart && GB.cart.refreshCount) GB.cart.refreshCount();
    }).catch(function () {});
    var footer = document.getElementById('main-cart-footer');
    if (footer && !sourceIsCartItems) {
      fetch(cartUrl() + '?section_id=' + footer.dataset.id, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#main-cart-footer .js-contents'), current = footer.querySelector('.js-contents');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshFooter = doc.getElementById('main-cart-footer');
          if (freshFooter) footer.classList.toggle('is-empty', freshFooter.classList.contains('is-empty'));
        }).catch(function () {});
    }
  }

  function cartUpdateEvent(source) {
    if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: source || 'gb-cart' });
    else window.location.reload();
  }

  /* ---------- Clicks & changes ---------- */
  document.addEventListener('click', function (e) {
    var save = e.target.closest('[data-gb-save-later]');
    if (save) {
      e.preventDefault();
      var line = save.closest('[data-gb-line]');
      if (window.GB && GB.wishlist) {
        if (!GB.wishlist.has(save.dataset.handle)) GB.wishlist.add(save.dataset.handle);
        GB.toast && GB.toast((window.GBConfig && GBConfig.wishlistAdded) || '', GBConfig && GBConfig.wishlistUrl ? { link: GBConfig.wishlistUrl, linkLabel: GBConfig.wishlistView } : {});
      }
      var remove = line && $('cart-remove-button', line);
      if (remove) remove.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
      return;
    }
    var checkout = e.target.closest('[data-gb-checkout]');
    if (checkout && !checkout.disabled) { setTimeout(function () { checkout.classList.add('is-loading'); }, 0); return; }
    var promo = e.target.closest('[data-gb-promo-apply]');
    if (promo) {
      var input = $('[data-gb-promo-input]', promo.closest('[data-gb-promo]'));
      var code = input && input.value.trim();
      if (!code) { input && input.focus(); return; }
      promo.classList.add('is-loading');
      var root = (promo.dataset.root || '/').replace(/\/$/, '');
      window.location.href = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(promo.dataset.cartUrl || cartUrl());
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-gb-promo-input]')) {
      e.preventDefault();
      var btn = $('[data-gb-promo-apply]', e.target.closest('[data-gb-promo]'));
      btn && btn.click();
    }
  });

  document.addEventListener('change', function (e) {
    var attr = e.target.closest('[data-gb-cart-attribute]');
    if (attr) {
      var attributes = {};
      attributes[attr.dataset.gbCartAttribute] = attr.checked ? (attr.dataset.value || 'Yes') : '';
      attr.classList.add('is-busy');
      fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attributes })
      }).catch(function () { attr.checked = !attr.checked; }).finally(function () { attr.classList.remove('is-busy'); });
      return;
    }
    var gift = e.target.closest('[data-gb-gift-product]');
    if (gift) {
      gift.classList.add('is-busy');
      var req;
      if (gift.checked) {
        req = fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(gift.dataset.gbGiftProduct), quantity: 1 }] })
        });
      } else {
        req = fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: gift.dataset.lineKey, quantity: 0 })
        });
      }
      req.then(function (r) { return r.json(); }).then(function () { cartUpdateEvent('gb-gift'); })
        .catch(function () { gift.checked = !gift.checked; })
        .finally(function () { gift.classList.remove('is-busy'); });
    }
  });


  /* ---------- Back-in-stock notify form (AJAX contact form) ---------- */
  if (!window.__gbNotify) {
    window.__gbNotify = true;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-gb-notify-form]');
      if (!form || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var wrap = form.closest('[data-gb-notify]');
      var status = form.querySelector('[data-gb-notify-status]');
      var btn = form.querySelector('[data-gb-notify-submit]');
      var fields = form.querySelector('[data-gb-notify-fields]');
      var show = function (msg, ok) {
        if (!status) return;
        status.hidden = false;
        status.textContent = msg;
        status.className = 'gb-notify__status gb-notify__status--' + (ok ? 'success' : 'error');
        status.setAttribute('role', ok ? 'status' : 'alert');
      };
      if (btn) btn.classList.add('is-loading');
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (/challenge/.test(r.url)) { form.removeAttribute('data-gb-notify-form'); form.submit(); return null; }
          return r.text().then(function (html) { return { url: r.url, html: html }; });
        })
        .then(function (res) {
          if (!res) return;
          var ok = /contact_posted=true/.test(res.url) || /posted_successfully|form-status--success|contact_posted=true/.test(res.html);
          var hasErrors = /class="[^"]*errors/.test(res.html) && !/contact_posted=true/.test(res.url);
          if (ok && !hasErrors) {
            if (fields) fields.hidden = true;
            show(wrap ? wrap.dataset.success : '', true);
            wrap && wrap.classList.add('is-success');
          } else {
            show(wrap ? wrap.dataset.error : '', false);
          }
        })
        .catch(function () { show(wrap ? wrap.dataset.error : '', false); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    init(document);
    observe($('cart-drawer'));
    observe($('cart-items'));
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (document.getElementById('main-cart-items')) refreshPage(ev && ev.source === 'cart-items');
      });
    }
    document.addEventListener('gb:cart:added', function () { syncDrawerState(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.GBCartDrawer = { init: init };
})();
